module.exports = __webpack_public_path__ + "static/img/t4.92e846f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/t4.png
// module id = IcvD
// module chunks = 1